import { gql } from 'src/__generated__';

export const SUBMIT_APPLICATION = gql(`
  mutation ApplySubmitApplication(
    $input: SubmitApplicationInput!
    $locale: Locale
  ) {
    submitApplication(input: $input) {
      ... on SubmitApplicationSuccess {
        applicationId
      }
      ... on SubmitApplicationFailure {
        errors {
          message(locale: $locale)
          __typename
        }
      }
    }
  }
`);
